import { Flex, Link, Stack, Image, Heading } from '@chakra-ui/react';
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import mainLogo from 'packages/common-frontend/images/Logo-Horizontal-Normal.svg';

export const SignupSideColumn = () => {
  const [logoLoaded, setLogoLoaded] = useState(false);
  return (
    <Stack
      height="100%"
      spacing={4}
      w={{ base: '80%', md: '40%' }}
      align={['center', 'center', 'flex-start', 'flex-start']}
    >
      <Flex
        width="100%"
        paddingLeft="15px"
        textAlign="center"
        marginBottom="20px"
      >
        <Link as={RouterLink} to="/" style={{ margin: 'auto' }}>
          <Image
            src={mainLogo}
            alt="Logo"
            width="120px"
            display={logoLoaded ? 'block' : 'none'}
            onLoad={() => {
              setLogoLoaded(true);
            }}
          />
        </Link>
      </Flex>
      <Heading
        as="h3"
        size="lg"
        textAlign="center"
        marginBottom="30px"
        fontWeight="300"
      >
        Streamline your debt capital raise and management
      </Heading>
    </Stack>
  );
};
